import { createSlice } from '@reduxjs/toolkit';
import { DashboardGig, dashboardEventDataInit, gigInit } from 'types/gig';

// initial state
const initialState = {
  gigsList: [] as DashboardGig[],
  detailsOpen: false,
  detailsData: {
    ...gigInit,
    ...dashboardEventDataInit
  } as unknown as DashboardGig
};

// ==============================|| SLICE - MENU ||============================== //

const dashboard = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setGigsList(state, action) {
      state.gigsList = action.payload;
    },
    setDetailsOpen(state, action) {
      state.detailsOpen = action.payload;
    },
    setDetailsData(state, action) {
      state.detailsData = action.payload;
    },
    setSingleGig(state, action) {
      const gigToUpdate = state.gigsList.find((gig) => gig.id === action.payload.id);
      if (gigToUpdate) {
        Object.assign(gigToUpdate, action.payload);
      }
    }
  }
});

export default dashboard.reducer;

export const { setGigsList, setDetailsOpen, setDetailsData, setSingleGig } = dashboard.actions;
